import { styled } from '@material-ui/core/styles'

export const StyledLink = styled('a')({
  wordBreak: 'break-all',
})
